import React from 'react';
import SolidLiquidForm from '../../components/forms/solidLiquidForm';

const SolidLiquid: React.SFC<any> = (props) => (
  <SolidLiquidForm {...props} />
);

export default SolidLiquid;
